import type { ReactNode } from "react";

type Props = { title: string; action?: ReactNode; children: ReactNode };

/** リソースUIの縦積みセクション（見出し＋右肩アクション＋本体）（②）。 */
export function Section({ title, action, children }: Props) {
    return (
        <section>
            <div className="mb-1.5 flex items-center">
                <h3 className="text-xs font-semibold text-text-secondary">{title}</h3>
                {action && <span className="ml-auto">{action}</span>}
            </div>
            {children}
        </section>
    );
}
